/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The application event type
 */
export enum ApplicationEventType {
    APPLICATION_MT_TRIAL_SIGNED_UP = 'APPLICATION_MT_TRIAL_SIGNED_UP',
    APPLICATION_MT_TRIAL_STOPPED = 'APPLICATION_MT_TRIAL_STOPPED',
    APPLICATION_MT_SUBSCRIPTION = 'APPLICATION_MT_SUBSCRIPTION',
    APPLICATION_MT_PERWORD = 'APPLICATION_MT_PERWORD',
    APPLICATION_MT_ENABLED = 'APPLICATION_MT_ENABLED',
    APPLICATION_MT_DISABLED = 'APPLICATION_MT_DISABLED',
    MT_DOC_ESCALATION_TO_HUMAN = 'MT_DOC_ESCALATION_TO_HUMAN',
    MT_MEDIA_ESCALATION_TO_HUMAN = 'MT_MEDIA_ESCALATION_TO_HUMAN',
    MT_DOC_TRANSLATION_REQUESTED = 'MT_DOC_TRANSLATION_REQUESTED',
    MT_MEDIA_TRANSLATION_REQUESTED = 'MT_MEDIA_TRANSLATION_REQUESTED',
    AI_POST_EDIT_REQUESTED = 'AI_POST_EDIT_REQUESTED',
    AI_POST_EDIT_ESCALATION_TO_HUMAN = 'AI_POST_EDIT_ESCALATION_TO_HUMAN',
    NEW_CLIENT_CONTACT_CREATED = 'NEW_CLIENT_CONTACT_CREATED',
    AUTO_QUOTE_ACCEPTED = 'AUTO_QUOTE_ACCEPTED',
    AUTO_QUOTE_REJECTED = 'AUTO_QUOTE_REJECTED',
    AUTO_QUOTE_FAILED = 'AUTO_QUOTE_FAILED',
    QUOTE_REQUESTED = 'QUOTE_REQUESTED',
    TRANSLATION_REQUESTED = 'TRANSLATION_REQUESTED',
    USER_LOGGED_IN = 'USER_LOGGED_IN',
    PROJECT_CANCELLATION_REQUESTED = 'PROJECT_CANCELLATION_REQUESTED',
    JOB_REQUEST_COMPLETED = 'JOB_REQUEST_COMPLETED',
}
